<!--
	@name common-structure-directory
	@description Video Player
	@date 2020/04/11
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<common-dialog ref="dialog" :component="$options.name">
		<template #body>
			<div v-if="vimeo && source" style="padding:56.25% 0 0 0;position:relative;">
				<iframe :src="source" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style="position:absolute;top:0;left:0;width:100%;height:100%;" />
			</div>
			<video v-else-if="source" width="100%" autoplay controls playsinline controlsList="nodownload" oncontextmenu="return false;">
				<source :src="source" type="video/mp4" />
			</video>
			<div v-else>
				<p>No video source available.</p>
			</div>
		</template>
	</common-dialog>
</template>

<script>
	import { EventBus } from '@/utils';
	import CommonDialog from '@/component/common/dialog';

	export default {
		name: 'app-dialog-video-player',

		components: { CommonDialog },

		data() {
			return {
				source: null,
				vimeo: false
			};
		},

		created() {
			EventBus.$on('common-dialog-closed', this.close);
		},

		destroyed() {
			EventBus.$off('common-dialog-closed', this.close);
		},

		methods: {
			/**
			 * @name open
			 * @description set source of the video and open dialog
			 */
			open(value, vimeo = false) {
				this.vimeo = vimeo;
				this.source = value;
				this.$refs.dialog.open();
			},

			close() {
				this.source = null;
			}
		}
	};
</script>

<style scoped></style>
